export {
  ComposerDictateSlot,
  type ComposerDictateSlotProps,
} from '@/components/ui/evidence-note-overlay/evidence-note-overlay-input-row';
